<template>
  <div class="vm-plan p16" :class="{'order-page': is_order_create}">
    <!-- {{plan.plan_id}} -->
    <plan-sale v-if="is_sale_type" :plan="plan" class="p8" :is_show_bundle_info="false" @click.native="jump_item"/>
    <template v-if="album">
      <div class="fs14 mb16">
        <div class="fs20 black-4 mb10">{{$t('c.Plan.text1')}} {{ plan.unlockNum }}/{{ album.post_count }} {{$t('c.Plan.text2')}}</div>
        <div class="flex-box flex-align-items-baseline lh1 mb16">
          <div class="old-price mr8" v-if="is_show_diff">
            <span class="black-3">￥{{ renew_plan.plan.price }}</span>
            <span class="ml8 mr8">→</span>
          </div>
          <div class="flex-box flex-align-items-center fs32">￥{{ plan.price }}</div>
          <span class="ml8" :class="{ forever: plan.permanent }">{{text_month}}</span>
          <span class="ml16 black-3" v-if="plan.sponsor_count > 0 && user.creator && user.creator.privacy_public_sponsor == 1">{{ plan.sponsor_count }} {{$t('c.Plan.text3')}}</span>
        </div>
        <div class="fs14 mb16" v-if="plan.name">
          <span
            v-if="renew_plan.plan && is_show_diff"
            :class="{ 'black-3': is_show_diff }"
          >{{ renew_plan.plan.name }}</span>
          <template v-if="is_show_diff">
            <span class="ml8 mr8">→</span>
          </template>
          <div>{{ plan.name }}</div>
          <div>{{ plan.desc }}</div>
        </div>
        <div
          class="flex-box flex-direction-row-reverse mt16"
          v-if="!is_no_btn && !is_applying_apple && !is_applying_google"
        >
          <template
            v-if="
                            renew_plan.plan_id &&
                            plan.independent != 1 &&
                            plan.plan_id != renew_plan.plan_id &&
                            plan.price * 1 < renew_plan.plan.price * 1
                        "
          >
            <span class="black-3">{{ btn_text }}</span>
          </template>
          <template v-else>
            <div class="btn-box">
              <btn :text="btn_text" @click.native="jump" class="size48 w100"></btn>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-else-if="!is_custom">
      <template v-if="product_type == 0">
      <div class="fs14 mb16" v-if="(plan && plan.name) || (renew_plan.plan && renew_plan.plan.name && is_show_diff) || (plan && plan.independent == 1)">
        <span
          v-if="renew_plan.plan && is_show_diff"
          :class="{ 'black-3': is_show_diff }"
        >{{ renew_plan.plan.name }}</span>
        <template v-if="is_show_diff">
          <span class="ml8 mr8">→</span>
        </template>
        <span v-if="plan.name" class="mr8">{{ plan.name }}</span>
        <span v-if="plan.independent == 1" class="black-3">{{$t('c.Plan.text4')}}</span>
      </div>
      <div class="flex-box flex-align-items-baseline lh1" v-if="!hard_code_plan_redeem">
        <div class="old-price mr8" v-if="is_show_diff">
          <span class="black-3">￥{{ renew_plan.plan.price }}</span>
          <span class="ml8 mr8">→</span>
        </div>
        <div class="flex-box flex-align-items-center fs32">
          ￥{{plan_price}}
        </div>
        <del
          v-if="plan.plan_id == `f44e055a0dd111eb829252540025c377`"
          class="black-3 ml16"
        >(原价 ￥149)</del>
        <span class="ml8" :class="{ forever: plan.permanent }">{{text_month}}</span>
        <del v-if="plan.show_price_after_adjust" class="ml4 black-3">￥{{plan.show_price}}</del>
        <span class="ml16 black-3" v-if="plan.plan_id == 'a952a1f62c9d11eb9c2152540025c377'">限量剩余 {{10 - plan.sponsor_count}} / 10</span>
        <span class="ml16 black-3" v-if="plan.sponsor_count > 0 && user.creator && user.creator.privacy_public_sponsor == 1">{{ plan.sponsor_count }} {{$t('c.Plan.text5')}}</span>
      </div>
      </template>
      <pre-box class="mt16" v-if="plan.desc && plan.product_type == 0" :text="plan.desc" :n="is_order_create ? 14 : 1000"></pre-box>
      <article-box v-if="plan.desc && is_sale_type" class="mt16" :text="plan.desc" :n="200" :is_n2br="true" :is_html2br="true" :open_text="$t('c.Plan.text6')" :url="$route.name == 'orderCreate' ? false : `/item/${plan.plan_id}`" :is_plan_style="true"></article-box>
      <div v-if="plan.total_count" class="mt16 black-8 fwb">
        <span>￥{{ plan.time_limit_price ? plan.floor_price : plan.is_vip == 1 ? plan.vip_price : plan.price }} {{$t('c.Plan.text7')}}</span>
        <span class="ml8 mr8">x</span>
        <span>{{(plan.product_type == 2 || plan.product_type == 3) ? 1 : plan.total_count }}{{$t('c.Plan.text8')}}</span>
      </div>
      <div v-if="sku_detail.length > 0" class="mt16 black-3 fs12">
        <div v-for="(item, i) in sku_detail" :key="i">{{ item.name }} * {{ plan.product_type == 2 ? 1 : item.count }}</div>
      </div>
      <div v-if="sku_name" class="mt16 black-3 fs12">
        {{sku_name}}
      </div>
      <div class="img-box mt16" :class="{'max-width-100': is_img_max_width_100}" v-if="!is_no_pic && plan.pic && product_type == 0">
        <div class="img-pre-box" @click="open_img(plan.pic)">
          <pic width="320" height="180" type="3" :src="plan.pic"></pic>
        </div>
      </div>
      <div class="flex-box mt16" v-if="plan.badge && plan.badge.badge_set && plan.badge.badge_set.length > 0">
        <pic v-for="(item, i) in plan.badge.badge_set" :key="i" class="mr8 wh32" :src="item.image" type="5" width="32" height="32"
          v-tooltip.right-start="{content:`${item.desc}`,trigger:browser_size == 'small' ? 'click':`hover`, classes:'look7'}"/>
      </div>
      <div class="flex-box flex-wrap" v-if="product_type == 0">
        <div class="group-tag fwb mt16 mr8" v-if="plan.group">{{$t('c.Plan.text9')}}{{ plan.group.title }}</div>
        <div class="unlock-tag fwb mt16 black-3 mr8" :class="{'gl-hover-text': is_plan_call_filter}" v-if="plan.unlockNum > 0" @click="tap_unlock">
          <i class="afd afd-unlock mr8 fs12"></i>
          {{$t('c.Plan.text10')}} {{ plan.unlockNum }} {{$t('c.Plan.text11')}}
        </div>
        <div class="unlock-tag fwb mt16 black-3 mr8" v-if="plan.has_vip">{{$t('c.Plan.text12')}}</div>
        <div class="unlock-tag fwb mt16 black-3" v-if="plan.has_badge" v-tooltip.top="{content:`${$t('c.Plan.text13')}<br>${$t('c.Plan.text14')}`,trigger:browser_size == 'small' ? 'click':`hover`, classes:'look6'}">{{$t('c.Plan.text15')}}</div>
      </div>
      <div class="flex-box flex-direction-row-reverse mt16" v-if="!is_no_btn && !is_applying_apple && !is_applying_google">
        <template v-if="is_sale_type">
        <!-- $mixin_show_sheet_sale({ plan_id: plan.plan_id }) -->
          <btn
            @click.native="jump"
            :text="btn_text"
            class="size48"
          ></btn>
        </template>
        <template
          v-else-if="
                        plan.independent == 0 &&
                        renew_plan.plan_id &&
                        plan.plan_id != renew_plan.plan_id &&
                        plan.price * 1 < renew_plan.plan.price * 1
                    "
        >
          <span class="black-3">{{ btn_text }}</span>
        </template>
        <template v-else>
          <div class="btn-box">
            <btn :text="btn_text" @click.native="jump" class="size48 w100"></btn>
          </div>
        </template>
      </div>
    </template>
    <template v-else-if="album == null && is_custom">
      <div class="flex-box flex-align-items-baseline lh1">
        <div class="flex-box flex-align-items-center fs24">{{custom_plan_tit}}</div>
        <span class="ml8">{{ text_month }}</span>
        <span class="ml16 black-3" v-if="custom_times && custom_times > 0">{{ custom_times }} {{$t('c.Plan.text16')}}</span>
      </div>
      <pre-box class="mt16" :text="custom_plan_desc"></pre-box>
      <div class="flex-box flex-direction-row-reverse mt16" v-if="!is_no_btn && !is_applying_apple && !is_applying_google">
        <router-link
          class="btn-box"
          :to="{name: 'orderCreate',query: { user_id: user.user_id },}"
        >
          <btn :text="`${$t('c.Plan.text32')}${$t('c.Plan.text17')}`" class="size48 w100"></btn>
        </router-link>
      </div>
    </template>
    <!-- <btn @click.native="$mixin_show_sheet_sale">test</btn> -->
  </div>
</template>

<script>
import {
    GET_USER_IDCARD
} from "@/api/config";
import { mapState } from "vuex";
export default {
  name: "plan",
  props: {
    plan: {
      type: Object,
      default() {
        return {};
      },
    },
    album: {
      type: Object,
      default() {
        return null;
      },
    },
    is_no_btn: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_no_pic: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_show_diff: {
      type: Boolean,
      default() {
        return false;
      },
    },
    renew_plan: {
      type: Object,
      default() {
        return {};
      },
    },
    is_custom: {
      type: Boolean,
      default() {
        return false;
      },
    },
    is_plan_call_filter: {
      default() {
        return false;
      },
    },
    user: {
      type: Object,
      default() {
        return {};
      },
    },
    // custom_text: {
    //   type: String,
    //   default() {
    //     return `本方案可反复发电。`;
    //   },
    // },
    custom_times: {
      type: [String, Number],
      default() {
        return 0;
      },
    },
    renew_infos_independent: {
      type: Array,
      default() {
        return [];
      },
    },
    product_type: {
      type: [String, Number],
      default() {
        return 0;
      },
    },
    sku_detail: {
      default() {
        return [];
      },
    },
    sku_name:{
       default() {
        return '';
      },
    }
  },
  components: {},
  data() {
    return {
      identity:null,
    };
  },
  computed: {
    ...mapState("app", [
      "browser_size",
      "is_applying_apple",
      "is_applying_google",
      "session_user",
      "white_list",
    ]),
    ...mapState("user", ["this_user"]),
    is_img_max_width_100(){
      return this.this_user && this.this_user.user_id == 'a0938a40f75d11eb8e8e52540025c377'
    },
    is_zhang_plan() {
      return this.white_list.PLANS_ZHANG.indexOf(this.plan.plan_id) != -1;
    },
    is_fen_plan() {
      return this.white_list.PLANS_FEN.indexOf(this.plan.plan_id) != -1;
    },
    is_year_plan() {
      return this.white_list.PLANS_YEAR.indexOf(this.plan.plan_id) != -1 || this.plan.pay_month == 12;
    },
    is_q_plan() {
      return this.white_list.PLANS_Q.indexOf(this.plan.plan_id) != -1 || this.plan.pay_month == 3;
    },
    is_order_create(){ //创建订单页有ui变化
        return this.$route.name == 'orderCreate'
    },
    is_sale_type(){
      return this.plan && [1,2,3,4,'1','2','3','4'].indexOf(this.plan.product_type) != -1
    },
    hard_code_plan_redeem(){
      let plans = this.white_list.PLANS_LINGQU.map(v => v.plan_id);
      let paths = this.white_list.PLANS_LINGQU.map(v => v.path); 
      let index = plans.indexOf(this.plan.plan_id)
      if(index != -1){
        return paths[index]
      }
      return ''
    },
    custom_plan_desc() {
      return (
        (this.this_user &&
          this.this_user.creator &&
          this.this_user.creator.custom_plan_desc) ||
        `本方案可反复发电。`
      );
    },
    custom_plan_tit() {
      let text = this.$t('c.Plan.text31')
      if (this.this_user.user_id == "ac0b2d20e82111eaa97952540025c377") {
        text = "友情赞助";
      }
      return text;
    },
    plan_price() {
      if (this.plan.plan_id == "a103c78cc4f611ea843652540025c377") {
        return "350";
      }
      if (this.plan.plan_id == "11f87684e6b311eb86c452540025c377") {
        return "199.10";
      }
      if (this.plan.plan_id == "b5f231e2e84611ea93df52540025c377") {
        return "496.8";
      }
      if (this.plan.plan_id == "02b87afa0f0111ebaa8f52540025c377") {
        return "720";
      }
      if(this.plan.plan_id == 'a8beb5ccf14111eb99e052540025c377'){
        return "360";
      }
      if(this.plan.plan_id == 'a2de0554f14111eb834052540025c377'){
        return "90";
      }
      if (this.plan.show_price_after_adjust) { //server 调价
        return this.plan.show_price_after_adjust;
      }
      if (this.plan.pay_month > 1) {
        return this.plan.show_price;
      }
      if (this.plan.total_price) {
        return this.plan.total_price;
      }
      return this.is_year_plan
        ? this.plan.price * 12
        : this.is_q_plan
        ? this.plan.price * 3
        : this.plan.price;
    },
    btn_text() {
      let renew_plan = this.renew_plan;
      if(this.hard_code_plan_redeem){
        return this.$t('c.Plan.text18')
      }
      if (this.is_sale_type) {
        let text = this.$t('c.Plan.text19')
        if (
          this.plan.plan_id == "94d4f46e0dcf11ebab1b52540025c377" ||
          this.plan.plan_id == "ae69e34e0dd411eb946d52540025c377"
        ) {
          text = this.$t('c.Plan.text20')
        }
        // if(this.plan.floor_price && this.plan.floor_price != ''){
        //   return `${text} ￥${this.plan.is_vip == 0 ? this.plan_price : this.plan.floor_price}`;
        // }
        return `${text} ￥${this.plan.is_vip == 1 ? (this.plan.floor_price != '' ? this.plan.floor_price : this.plan.vip_price ) : this.plan.time_limit_price ? this.plan.time_limit_price.price : this.plan_price}`;
      }

      if (this.plan.independent == 1) {
        this.renew_infos_independent.forEach((v) => {
          if (v.plan_id == this.plan.plan_id) {
            renew_plan = v;
          }
        });
        if (renew_plan.plan_id == this.plan.plan_id) {
          return `${this.$t('c.Plan.text21')} ￥${this.plan_price} ${this.text_month}`;
        } else {
          return `${this.$t('c.Plan.text22')} ￥${this.plan_price} ${this.text_month}`;
        }
      }

      if (renew_plan.plan_id) {
        if (this.plan.plan_id == renew_plan.plan_id) {
          return `${this.$t('c.Plan.text21')} ￥${this.plan_price} ${this.text_month}`;
        } else if (this.plan.price * 1 < renew_plan.plan.price * 1) {
          return  this.$t('c.Plan.text23');
        } else if (this.plan.price * 1 == renew_plan.plan.price * 1) {
          return `${this.$t('c.Plan.text19')} ￥${this.plan_price} ${this.text_month}`;
        } else {
          return `${this.$t('c.Plan.text24')} ￥${this.plan_price} ${this.text_month}`;
        }
      } else {
        return `${this.$t('c.Plan.text19')} ￥${this.plan_price} ${this.text_month}`;
      }
    },
    text_month() {
    //   if (
    //     (this.session_user &&
    //       this.session_user.user_id == "5e74251ec2ce11e8bf7352540025c377") ||
    //     (this.user.user_id &&
    //       this.user.user_id == "5e74251ec2ce11e8bf7352540025c377") ||
    //     this.product_type == 1
    //   ) {
    //     return "";
    //   }
      if (
        this.is_fen_plan ||
        this.is_sale_type ||
        (this.is_custom &&
          this.white_list.PLANS_CUSTOM.indexOf(this.user.user_id) != -1)
      ) {
        // if (this.user.user_id == '4f7112d8dd4411eaa61252540025c377') {
        //   this.custom_plan_desc = '视频还是免费观看，喜欢的朋友随缘打赏';
        // }
        return this.$t('c.Plan.text25');
      }
      if (this.is_zhang_plan) {
        return this.$t('c.Plan.text26');
      }
      if (this.plan.permanent) {
        return this.$t('c.Plan.text27');
      }
      if (this.is_q_plan) {
        return this.$t('c.Plan.text28');
      }

      if (this.is_year_plan) {
        return this.$t('c.Plan.text29');
      }
      return this.$t('c.Plan.text30');
    },
  },
  mounted() {},
  methods: {
    jump_item(){
      if(this.GL.ENV.is_wechat){
        return false;
      }
      this.$mixin_router_push(`/item/${this.plan.plan_id}`,'','','', this.plan)
    },
    tap_unlock(){
      this.$bus.$emit('FEED_UNLOCK_TAP',{
        key:'plan_id',
        value:this.plan.plan_id,
      })
    },
    open_img(src) {
      this.$mixin_show_modal_img(0, [src]);
    },
    async get_identity() {
        if (this.$http.is_run(GET_USER_IDCARD)) {
            return false;
        }
        let data = await this.$http.$axios(GET_USER_IDCARD);

        if (data.ec != 200) {
            this.$notify({
                title: data.em,
                group: "error"
            });
            return false;
        }
        if(data.data.user_id){
          this.identity = data.data
        }
    },
    async jump(){
    //   if(this.plan && this.plan.plan_id == 'b06dc7841dd611ebb4d252540025c377' && this.plan.sponsor_count >= 200){
    //       this.$notify({
    //           title: "没有库存了",
    //           group: "error",
    //       });
    //       return false;
    //   }
      if(this.hard_code_plan_redeem){
        this.$mixin_router_push(this.hard_code_plan_redeem)
        return false;
      }

      if(this.plan && this.plan.plan_id == 'a952a1f62c9d11eb9c2152540025c377' && this.plan.sponsor_count >= 10){
          this.$notify({
              title: "没有库存了",
              group: "error",
          });
          return false;
      }
      if([1,3,4,'1','3','4'].indexOf(this.plan.product_type) != -1){
        if(this.plan.product_type == 4 && !this.identity){
          if(!this.session_user){
            this.$store.commit('app/set:redirect_url', this.$route.fullPath);
            this.$mixin_router_push('/login');
            return false
          }
          await this.get_identity();
          if(!this.identity){
            this.$mixin_show_modal_identity({
              is_show_tip:true,
              is_self:1,
            });
            return false
          }
        }
        this.$mixin_show_sheet_sale({ plan_id: this.plan.plan_id })
        return false;
      }
      this.$router.push({name: 'orderCreate',query: { plan_id: this.plan.plan_id,product_type: this.plan.product_type }})
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-plan {
  background: $white;
  border-radius: px2rem(4);
  border: 1px solid $grey;
  position: relative;

  &.order-page{
    border: 0;
  }
  &.look2 {
    padding: 0;
    border: 0;
  }

  .afd-x {
    position: absolute;
    right: px2rem(16);
    top: px2rem(16);
    cursor: pointer;

    &:hover {
      color: $black-8;
    }
  }

  .w50 {
    width: 50%;
  }

  .img-box {
    max-width: px2rem(320);
    cursor: zoom-in;

    .img-pre-box {
      margin-bottom: px2rem(16);

      img {
        width: auto;
        max-width: 100%;
      }
    }
  }

  .old-price {
    /* text-decoration:line-through */
  }

  &.on {
    border-color: $purple;
    box-shadow: 0 px2rem(4) px2rem(10) $purple-2;
  }

  &.hover:hover {
    box-shadow: 0 px2rem(4) px2rem(10) $black-1;
  }

  // .vm-btn {
  // width: px2rem(160);
  // }
  .group-tag {
    // border: 1px solid $group;
    border-radius: 20px;
    padding: 10px 16px;
    color: $group;
    font-size: 12px;
    background: $group-3;
  }

  .unlock-tag {
    // border: 1px solid $group;
    border-radius: 20px;
    padding: 10px 16px;
    color: #4F4F4F;
    font-size: 12px;
    background: $white-bg;
  }

  @media (max-width: $width-mobile) {
    .btn-box, .vm-btn {
      width: 100%;
    }
    .img-box.max-width-100 {
      max-width: 100%;
    }
  }
}
</style>
